import { identityAccountId, IdentityAccountId } from "@common/domain";
import {
  IAMAccountIdentity,
  iamAccountIdentity
} from "@youm-front/iam-account/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class IAMAccountUpdateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountUpdateRequestDTO.validationSchema()
  );

  constructor(readonly data: IAMAccountUpdateRequestDTORaw) {
    JsonSchemaValidator.validate(IAMAccountUpdateRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["accountId", "identity"],
      properties: {
        accountId: identityAccountId,
        identity: iamAccountIdentity
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountUpdateRequestDTORaw {
  accountId: IdentityAccountId;
  identity: IAMAccountIdentity;
}
